export const WithdrawalRequestMap = {
  GET_WITHDRAWAL_REQUEST_START: "GET_WITHDRAWAL_REQUEST_START",
  GET_WITHDRAWAL_REQUEST_SUCCESS: "GET_WITHDRAWAL_REQUEST_SUCCESS",
  GET_WITHDRAWAL_REQUEST_ERROR: "GET_WITHDRAWAL_REQUEST_ERROR",
  GET_WITHDRAWAL_REQUEST_SEARCH_TEXT_CHANGE:
    "GET_WITHDRAWAL_REQUEST_SEARCH_TEXT_CHANGE",
  GET_WITHDRAWAL_REQUEST_SELECT_TEXT_CHANGE:
    "GET_WITHDRAWAL_REQUEST_SELECT_TEXT_CHANGE",
  GET_WITHDRAWAL_REQUEST_REFRESH_TOKEN_TXN_LIST:
    "GET_WITHDRAWAL_REQUEST_REFRESH_TOKEN_TXN_LIST",
  UPDATE_WITHDRAWAL_REQUEST_START: "UPDATE_WITHDRAWAL_REQUEST_START",
  UPDATE_WITHDRAWAL_REQUEST_SUCCESS: "UPDATE_WITHDRAWAL_REQUEST_SUCCESS",
  UPDATE_WITHDRAWAL_REQUEST_ERROR: "UPDATE_WITHDRAWAL_REQUEST_ERROR",
  SET_WITHDRAWAL_REQUEST_BATCH_NUMBER: "SET_WITHDRAWAL_REQUEST_BATCH_NUMBER",
  SET_TO_DATE_CHANGES: "SET_TO_DATE_CHANGES",
  SET_FROM_DATE_CHANGES: "SET_FROM_DATE_CHANGES",
  RESET_FILTERS: "RESET_FILTERS",
  SET_PENDING_WITHDRAWAL_COUNT: "SET_PENDING_WITHDRAWAL_COUNT",
};

export const WithdrawalRequestActions = {
  getWithdrawalRequestStart: (data) => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_START,
    payload: data,
  }),
  getWithdrawalRequestSuccess: (data) => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SUCCESS,
    payload: data,
  }),
  getWithdrawalRequestError: (errors) => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_ERROR,
    payload: { errors },
  }),
  getWithdrawalRequestRefreshList: () => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_REFRESH_TOKEN_TXN_LIST,
  }),
  getWithdrawalRequestSearchTextChange: (data) => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SEARCH_TEXT_CHANGE,
    payload: data,
  }),
  getWithdrawalRequestSelectTextChange: (updatedFields) => ({
    type: WithdrawalRequestMap.GET_WITHDRAWAL_REQUEST_SELECT_TEXT_CHANGE,
    payload: updatedFields,
  }),
  updateWithdrawalRequestStart: (data) => ({
    type: WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_START,
    payload: data,
  }),
  updateWithdrawalRequestSuccess: (data) => ({
    type: WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_SUCCESS,
    payload: data,
  }),
  updateWithdrawalRequestError: (errors) => ({
    type: WithdrawalRequestMap.UPDATE_WITHDRAWAL_REQUEST_ERROR,
    payload: { errors },
  }),
  setVirtualTokenBatchNumber: (data) => ({
    type: WithdrawalRequestMap.SET_WITHDRAWAL_REQUEST_BATCH_NUMBER,
    payload: data,
  }),
  toDateChanges: (data) => ({
    type: WithdrawalRequestMap.SET_TO_DATE_CHANGES,
    payload: data,
  }),
  fromDateChanges: (data) => ({
    type: WithdrawalRequestMap.SET_FROM_DATE_CHANGES,
    payload: data,
  }),
  resetFilters: (data) => ({
    type: WithdrawalRequestMap.RESET_FILTERS,
    payload: data,
  }),
  setPendingWithdrawalCount: (count) => ({
    type: WithdrawalRequestMap.SET_PENDING_WITHDRAWAL_COUNT,
    payload: count,
  }),
};
